import { HistoryService, HttpService, MessageService, ModalService, SessionStorageService } from '@philips-emr/tws-core/lib/services';
import { ResponseBodyMapperType } from '@philips-emr/tws-core/lib/services/http-service';
import { ModalProps } from '@philips-emr/tws-core/lib/services/modal-service';

import { Endpoint } from '../constants';

import { ToastServiceStipulator } from './toast-service';

interface Report {
  cdClassifRelat: string;
  cdRelatorio: string;
  dsTitulo: string;
  nrSequencia: string;
  cdGrupo: string;
  type: string;
  reportPath: string;
}

class ReportService {

  private cdGrupo: string;

  private reps: Report[];

  private nrSeqBeneficiario: string | number;

  private nrSeqContrato: string | number;

  private endpointLista: string;

  private parametrosLista: {};

  constructor(cdGrupo: string, endpointLista: string = '') {
    this.cdGrupo = cdGrupo;
    this.endpointLista = endpointLista;
    const { nrSeqContrato } = HistoryService.getCurrentRouteParams();
    this.nrSeqContrato = nrSeqContrato;

  }

  abreListaRelatorios(relatorioParametros: object, requestParametros: object = {}): void {
    this.getRelatoriosByCdGrupo(requestParametros)
      .then(reps => {
        if (reps.length > 0) {
          if (reps.length === 1) {
            void this.gerarRelatorio(reps[0].cdRelatorio, reps[0].cdClassifRelat, relatorioParametros);
            return;
          }
          this.abreModal(relatorioParametros);
          this.changeCursor(false);
        } else {
          ToastServiceStipulator.warning(MessageService.translate('stipulator.nao-ha-relatorio-disponivel'));
        }
      })
      .catch(() => this.changeCursor(false));
  }

  getRelatoriosByCdGrupo(requestParams: {} = {}): Promise<Report[]> {
    if (this.reps) {
      return Promise.resolve(this.reps);
    }

    if (requestParams) {
      this.parametrosLista = requestParams;
    }

    const params = { ...this.parametrosLista, cdGrupo: this.cdGrupo, nrSeqContrato: this.nrSeqContrato };

    const endpoint = this.endpointLista === '' ? Endpoint.GET.RELATORIOS_POR_GRUPO : this.endpointLista;

    return HttpService.get(endpoint, params)
      .then(resp => {
        this.reps = resp.body as Report[];
        return this.reps;
      });
  }

  private changeCursor(isProgress: boolean): void {
    document.body.style.cursor = isProgress ? 'wait' : 'default';
  }

  abrirEmNovaJanela(url: string): void {
    const win = window.open(url, '_blank');
    win && win.focus();
  }

  abreModal(relatorioParametros: object): void {
    SessionStorageService.setItem('dados_relatorios', {
      relatorioParametros,
      nrSeqBeneficiario: this.nrSeqBeneficiario,
      cdGrupo: this.cdGrupo,
      parametrosLista: this.parametrosLista,
      endpointLista: this.endpointLista,
    });

    const modalWithFragment: ModalProps = {
      closeable: true,
      fragment: 'hpms-reports-modal',
      title: 'stipulator.relatorios',
      contextData: this.parametrosLista,
      className: 'modal-reports',
    };
    ModalService.openDefault(modalWithFragment);
  }

  abreRelatorio(src: string): void {
    const modalWithFragment: ModalProps = {
      closeable: true,
      fragment: 'pdf-viewer',
      contextData: { src },
    };
    ModalService.openFullscreen(modalWithFragment);
  }

  async gerarRelatorio(cdRelatorio: string, tipoRelatorio: string, parametrosRelatorio: object): Promise<void> {
    this.changeCursor(true);

    const body = {
      code: cdRelatorio,
      parameters: parametrosRelatorio,
      type: tipoRelatorio,
    };

    const responseBodyMapperType: ResponseBodyMapperType = ResponseBodyMapperType.BLOB;

    const requestParams = {
      cdGrupo: this.cdGrupo,
      nrSeqContrato: this.nrSeqContrato,
    };

    return HttpService.post(Endpoint.POST.CONTEUDO_RELATORIO, requestParams, { body, responseBodyMapperType })
      .then(response => {
        const { type } = response.body as Report;
        const file = new Blob([response.body as Blob], { type: type });

        if (type == 'application/json') {
          void file.text().then((response) => {
            this.abreRelatorio(response);

          });
        } else {
          const url = URL.createObjectURL(file);
          this.abrirEmNovaJanela(url);
        }

      })
      .finally(() => this.changeCursor(false));
  }
}

export {
  ReportService, Report,
};

